import React, { useEffect } from "react";
import { FaWhatsapp } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import TawkToWidget from "../components/chat/TawkToWidget";

interface WhatsAppButtonProps {
  phoneNumber: string;
  message?: string;
}

const WhatsAppButton: React.FC<WhatsAppButtonProps> = ({
  phoneNumber,
  message,
}) => {
  const location = useLocation();

  const hiddenRoutes = [
    "/invoices",
    "/expenses",
    "/user-management",
    "/inventories",
    "/customers",
    "/quotes",
    "/projects",
  ];
  const shouldHideButton = hiddenRoutes.some((route) =>
    location.pathname.startsWith(route),
  );

  if (!shouldHideButton)
    return <TawkToWidget shouldHideButton={shouldHideButton} />;

  return null;
};

export default WhatsAppButton;
